var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.$router.currentRoute.fullPath,staticClass:"classes"},[_c('h1',[_vm._v("This is a help page")])])}
var staticRenderFns = []

export { render, staticRenderFns }